import React from "react";
import {
  chartTickPriceFormatWrapper,
  priceDecoratorWrapper,
} from "../../../../styles/cell-decorators";
import ChartComponent from "../../../../components/dashboard-components/chart-component/chart-component";

export default function CategoriesTotalRevenueChartComponent(props) {
  const { currency } = props;
  return (
    <ChartComponent
      {...props}
      title={"Category Total Sales Dollars"}
      currentKey={"currentTotalRevenue"}
      previousKey={"previousTotalRevenue"}
      changeKey={"revenueChange"}
      taglineSubject={"The category total sales dollars"}
      legendName={"Total sales dollars"}
      yTickFormat={chartTickPriceFormatWrapper(currency)}
      valueDecorator={priceDecoratorWrapper(
        props.currency,
        "total_sales_dollars_"
      )}
    />
  );
}
